"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCL = function FlagCL(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-178.88,12.18V5.12H-193V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H-65.88a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-123.19-85l6.73,20.19,21.28.16A2.87,2.87,0,0,1-93.5-59.5l-17.11,12.64,6.41,20.29a2.86,2.86,0,0,1-4.4,3.19l-17.31-12.37-17.31,12.37a2.86,2.86,0,0,1-4.4-3.19l6.41-20.29L-158.32-59.5a2.87,2.87,0,0,1,1.67-5.18l21.29-.16L-128.63-85a2.87,2.87,0,0,1,5.44,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCL;
exports["default"] = _default;